import { Link } from "react-router-dom";
import Nav from "../Nav";
import Head from "../Head";

const Proyectos = () => {
  window.scrollTo(0, 0);

  return (
    <>
      <Head title="Proyectos" />
      <Nav titulo="Proyectos" link="/" />
      <section
        id="menu"
        className="animate__fadeInDown wow animate__animated animate__delay-0s animate__slower"
      >
        <div className="cardMenu">
          <img
            src="../../img/fotogramas/fotogramas_botanicos_3.jpg"
            alt="Fotogramas botánicos"
            className="img-fluid"
          />
          <Link to={"./fotogramas_botanicos"} className="boton">
            Fotogramas botánicos
          </Link>
        </div>
        <div className="cardMenu">
          <img
            src="../../img/jacinto_de_agua_comun/jacinto_de_agua_comun_1.jpg"
            alt="Jacinto de agua común"
            className="img-fluid"
          />
          <Link to={"./jacinto"} className="boton">
            Jacinto de agua común
          </Link>
        </div>
        <div className="cardMenu">
          <img
            src="../../img/herbario_domestico/herbario_domestico_12.jpg"
            alt="Herbario doméstico"
            className="img-fluid"
          />
          <Link to={"./herbario_domestico"} className="boton">
            Herbario doméstico
          </Link>
        </div>
      </section>
    </>
  );
};

export default Proyectos;
